<template>
        <v-card  color="grey lighten-4" class="black--text" style="margin: 16px; position: relative">
        <div style="position: absolute; right: 0; top: 0; padding: 8px">
            <v-menu offset-y>
                <v-btn small :color="items[0].status === 'Completed' ? 'green' : 'red'" flat slot="activator" >
                    {{items[0].status}}
                </v-btn>
                <v-card>
                    <v-list>
                        <v-list-tile @click="setStatus('Completed')" >
                            <v-list-tile-title>Completos</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="setStatus('Missing')" >
                            <v-list-tile-title>Faltan</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </v-menu>
            <v-dialog v-model="dialog" persistent max-width="290">
                <v-btn slot="activator"  small flat color="red">DELETE</v-btn>
                <v-card>
                    <v-card-title class="headline">Borrar esta información</v-card-title>
                    <v-card-text>¿Estás seguro de que quieres eliminar esta información? Esta acción es irreversible y no se borrarán los datos de la reserva</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click="deleteItem">Borrar</v-btn>
                        <v-btn color="grey darken-1" flat @click="dialog = false">Cancelar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            </div>
        <v-container >
            <v-layout row wrap>
                <v-flex xs12 hidden-md-and-up>

                </v-flex>
                <v-flex xs12>
                    <h3 style="padding-top: 8px" class="title">{{ items[0].name +' '+items[0].lastname }}</h3>
                </v-flex>
                <v-flex xs6 md2>
                    <div class="caption" style="opacity: 0.7">Unidad</div>
                    <div>{{ items[0].unidad ? items[0].unidad: items[0].rama }}</div>
                </v-flex>
                <v-flex xs6 md2>
                    <div class="caption" style="opacity: 0.7">Fecha de nacimiento</div>
                    <div>{{ items[0].birthday }}</div>
                </v-flex>
                <v-flex xs6 md2>
                    <div class="caption" style="opacity: 0.7">Dias</div>
                    <div v-if="items[0].days.length == 16">
                        Todos
                    </div>
                    <div v-else style="color:red;">
                        {{ items[0].days.join(' ')  }}
                    </div>
                </v-flex>
                <v-flex xs6 md2>
                    <div class="caption" style="opacity: 0.7">Bus</div>
                    <div v-if="items[0].days.length = 2">
                        Ambas
                    </div>
                    <div v-else style="color:red;">
                        {{ items[0].bus.join(' ')  }}
                    </div>
                </v-flex>
                <v-flex xs6 md2>
                    <div class="caption" style="opacity: 0.7">Peso</div>
                    <div>{{ items[0].peso }}</div>
                </v-flex>
                <v-flex xs6 md2>
                </v-flex>
                <v-flex xs12 md12>
                    <div style="display: inline-block;">
                        <div class="caption" style="opacity: 0.7">Documentos</div>
                        <v-btn outline v-if="items[0].seguridad_social && items[0].seguridad_social.length>0" @click="openFile(items[0].seguridad_social[0])">Seguridad Social</v-btn>
                        <v-btn outline v-if="items[0].cartilla_vacunacion && items[0].cartilla_vacunacion.length>0" @click="openFile(items[0].cartilla_vacunacion[0])">Cartilla Vacunación</v-btn>
                        <v-btn outline v-if="items[0].autorizacion && items[0].autorizacion.length>0" @click="openFile(items[0].autorizacion[0])">Autorización</v-btn>
                    </div>
                    <div style="display: inline-block; padding-left: 16px"  v-if="items[0].docs && items[0].docs.length>0">
                        <div class="caption" style="opacity: 0.7" >Archivos médicos</div>
                        <v-btn v-for="(doc, index) in items[0].docs" small icon :key="index" @click="openFile(doc)"><v-icon>insert_drive_file</v-icon></v-btn>
                    </div>
                </v-flex>

                <v-flex xs12 v-if="items[0].alergias">
                    <div class="caption" style="opacity: 0.7">Alergias</div>
                    <div>{{ items[0].alergias }}</div>
                </v-flex>
                <v-flex xs12 v-if="items[0].operaciones">
                    <div class="caption" style="opacity: 0.7">Operaciones</div>
                    <div>{{ items[0].operaciones }}</div>
                </v-flex>
                <v-flex xs12 v-if="items[0].enfermedades">
                    <div class="caption" style="opacity: 0.7">Enfermedades</div>
                    <div>{{ items[0].enfermedades }}</div>
                </v-flex>
            </v-layout>
        </v-container>
        <v-snackbar
                :timeout="600"
                bottom right
                v-model="snackbar"
        >
            {{ text }}
            <v-btn flat color="orange" @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
    export default {
        name: "person-item",
        data() {
           return {
                menu: false,
                snackbar: null,
                text: '',
                dialog: false,
                items: []
           }
        },
        firestore () {
            return {
                items: this.$db.collection('forms').doc('inscripciones').collection('people').where('status', '==', 'unrevised').limit(1)
            }
        },
        methods: {
            openFile(file){
                this.$storage.ref().child(file).getDownloadURL().then(function(url) {
                    window.open(url)
                }).catch(function(error) {
                    // Handle any errors
                });
            },
            deleteItem(){
                var vue = this
                this.dialog = false
                this.$db.collection('forms').doc('inscripciones').collection('people').doc(this.items[0].id).delete().then(function() {
                    vue.snackbar = true
                    vue.text = `Eliminado ${vue.items[0].id}`
                    // vue.$emit('delete')
                }).catch(function(error) {
                    console.log(error)
                    vue.snackbar = true
                    vue.text = `Error eliminando datos`
                });
            },
            setStatus (text) {
                var status = this.items[0].status
                this.items[0].status = text
                var vue = this
                this.$db.collection('forms').doc('inscripciones').collection('people').doc(this.items[0].id).update({
                    status: text
                }).then(function () {
                    vue.snackbar = true
                    vue.text = 'Cambios guardados'
                }).catch(function (error) {
                    vue.items[0].status = status
                    vue.snackbar  = true
                    vue.text =  'ERROR: No se han guardado los cambios'
                    console.error("Error writing document: ", error);
                })
            },
        }

    }
</script>

<style scoped>
    .Completed {
        color: darkgreen;
    }
</style>